import PlusOutlined from '@ant-design/icons/lib/icons/PlusOutlined';
import { Button, Table, Tooltip } from 'antd';
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { FilterValue, SorterResult } from 'antd/lib/table/interface';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { Link } from 'react-router-dom';
import userApi from '../../../apis/UserApi';
import LayoutComponent from '../../../components/LayoutComponent/LayoutComponent';
import CustomContext from '../../../context/CustomContext';
import { Page } from '../../../model/Elements';
import { User } from '../../../model/Entities';
import notificationService from '../../../services/NotificationService';
import tableService from '../../../services/TableService';
import styles from './UsersPage.module.scss';

class UsersPage extends Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }

    /** METHODS **/

    init = async () => {
        try {
            this.setState({ loading: true });
            const usersPage = await userApi.list(tableService.pageSize, 1);
            this.setState({ usersPage });
        } catch (error) {
        } finally {
            this.setState({ loading: false });
        }
    };

    list = async (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<User> | SorterResult<User>[],
    ) => {
        try {
            this.setState({ loading: true });
            const page = pagination.current!;
            const pageSize = pagination.pageSize!;
            let sortField, sortOrder;
            if (Array.isArray(sorter)) {
            } else {
                sortField = sorter.field as string[];
                sortOrder = sorter.order as string;
            }
            const usersPage = await userApi.list(pageSize, page, sortField, sortOrder);
            this.setState({ usersPage });
        } catch (error) {
            notificationService.displayError(error, this.props.intl);
        } finally {
            this.setState({ loading: false });
        }
    };

    /*** COMPONENTS ***/

    renderContent = (): React.ReactElement | undefined => {
        return (
            <>
                {this.renderToolbar()}
                <div className={styles.table}>{this.renderTable()}</div>
            </>
        );
    };

    renderToolbar = (): React.ReactElement | undefined => {
        return (
            <div className={styles.toolbar}>
                <h1>
                    <FormattedMessage id="users.title" />
                </h1>
                <Link to="/admin/users/new">
                    <Tooltip title={<FormattedMessage id="users.tooltip" />}>
                        <Button type="primary" className={styles.add} size="large" icon={<PlusOutlined />}>
                            <FormattedMessage id="users.add" />
                        </Button>
                    </Tooltip>
                </Link>
            </div>
        );
    };

    renderTable = (): React.ReactElement | undefined => {
        const { usersPage, loading } = this.state;
        const items = usersPage ? usersPage.items : [];
        const columns: ColumnsType<User> = [
            {
                title: <FormattedMessage id="users.givenName" />,
                dataIndex: ['profile', 'givenName'],
                key: 'profile.givenName',
                sorter: true,
                render: (value: string, user: User) => <Link to={`/admin/users/${user.id}`}>{value}</Link>,
            },
            {
                title: <FormattedMessage id="users.familyName" />,
                dataIndex: ['profile', 'familyName'],
                key: 'profile.familyName',
                sorter: true,
                render: (value: string, user: User) => <Link to={`/admin/users/${user.id}`}>{value}</Link>,
            },
            {
                title: <FormattedMessage id="users.gender" />,
                dataIndex: ['profile', 'gender'],
                key: 'profile.gender',
                render: (value: string, user: User) => <Link to={`/admin/users/${user.id}`}>{value}</Link>,
            },
            {
                title: <FormattedMessage id="users.email" />,
                dataIndex: ['profile', 'email'],
                key: 'profile.email',
                render: (value: string, user: User) => <Link to={`/admin/users/${user.id}`}>{value}</Link>,
            },
            {
                title: <FormattedMessage id="users.phone" />,
                dataIndex: ['profile', 'phone'],
                key: 'profile.phone',
                render: (value: string, user: User) => <Link to={`/admin/users/${user.id}`}>{value}</Link>,
            },
            {
                title: <FormattedMessage id="users.birthday" />,
                dataIndex: ['profile', 'birthday'],
                key: 'profile.birthday',
                render: (value: string, user: User) => <Link to={`/admin/users/${user.id}`}>{value}</Link>,
            },
        ];

        return (
            <Table
                dataSource={items}
                columns={columns}
                pagination={tableService.createPagination(usersPage)}
                rowKey="id"
                onChange={this.list}
                sortDirections={['ascend', 'descend']}
                showSorterTooltip={false}
                loading={loading}
            />
        );
    };

    render() {
        return <LayoutComponent page="admin-users" content={this.renderContent} />;
    }
}
export default injectIntl(UsersPage);

interface Props extends WrappedComponentProps {}

interface State {
    usersPage?: Page<User>;
    loading?: boolean;
}
